export * from './detail/contest-news-detail.page'
export * from './list/contest-news-list.page'
